import { EntityTypeEnum } from "@scrinz/dtos";
export function getIconForEntityType(type) {
    switch (type) {
        case EntityTypeEnum.System:
            return "settings";
        case EntityTypeEnum.Group:
            return "filter_none";
        case EntityTypeEnum.Organization:
            return "account_balance";
        case EntityTypeEnum.Display:
            return "tv";
        default:
            return null;
    }
}
//# sourceMappingURL=get-icon-for-entity-type.js.map